var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2251 10.8309C23.8605 10.4523 23.271 10.454 22.9084 10.8346L11.7168 22.5852C10.2648 24.1015 7.90659 24.1015 6.45191 22.5831C4.99831 21.0644 4.99832 18.6017 6.45208 17.0835L17.975 4.98705C18.8815 4.04043 20.3553 4.04043 21.2644 4.9891C22.1733 5.93822 22.1733 7.47711 21.2642 8.42651L11.7185 18.3949C11.7179 18.3955 11.7174 18.3962 11.7168 18.3969C11.3531 18.7746 10.7654 18.7741 10.4025 18.3951C10.039 18.0154 10.039 17.4001 10.4025 17.0205L15.0101 12.2078C15.3736 11.8281 15.3736 11.2125 15.01 10.8329C14.6464 10.4532 14.0569 10.4533 13.6933 10.833L9.08577 15.6456C7.99514 16.7845 7.99514 18.631 9.08585 19.77C10.1765 20.909 11.9447 20.909 13.0354 19.77C13.0367 19.7687 13.0377 19.7673 13.0389 19.7659L22.5808 9.80138C24.2171 8.09263 24.2171 5.32256 22.5808 3.61382C20.9443 1.90607 18.2919 1.90607 16.6566 3.61382L5.13369 15.7104C2.95452 17.9861 2.95452 21.6796 5.13526 23.9581C7.31744 26.2357 10.8544 26.2357 13.0352 23.9583L24.2286 12.2059C24.5912 11.8252 24.5896 11.2096 24.2251 10.8309Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/AddFile.43829920.svg";
export { ForwardRef as ReactComponent };